// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ofuog","label":"styles_label__1hqKd"};